import React from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Fab,
    Typography,
    Grid,
    Button,
    Divider,
} from "@material-ui/core";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import MailRoundedIcon from "@material-ui/icons/MailRounded";
import PhoneRoundedIcon from "@material-ui/icons/PhoneRounded";
import { makeStyles } from "@material-ui/core/styles";

import { connect } from "react-redux";
import { NavLink } from "react-router-dom";


const useStyles = makeStyles((theme) => ({




    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        // marginLeft: window.innerWidth > 700 ? "15rem" : "0",
    },

}));


function Footer(props) {
    const classes = useStyles();

    return (
        <div>
            <AppBar
                position="relative"
                color="primary"
                style={{ top: "auto", bottom: 0 }}
            >
                <div

                    className={classes.content}
                >
                    {/* <Typography>{props.website.website}</Typography> */}
                    <Grid
                        container
                        direction="column"
                        justify="flex-start"
                        alignItems="flex-start"
                    >
                        <Grid item>
                            <Typography>
                                {props.website.website
                                    ? props.website.website.header
                                    : ""}
                            </Typography>
                        </Grid>
                        <br />
                        <Grid item>
                            <Typography>
                                {props.website.website
                                    ? props.website.website.shopAddress
                                    : ""}
                            </Typography>
                        </Grid>
                        <br />
                        <Grid item>
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                direction="row"
                            >
                                <Grid item>
                                    {props.website.website ? (
                                        <a
                                            href={`${props.website.website.instagram}`}
                                        >
                                            <InstagramIcon />
                                        </a>
                                    ) : (
                                            <a href={`#`}>
                                                <InstagramIcon />
                                            </a>
                                        )}
                                </Grid>
                                <Grid item>
                                    {props.website.website ? (
                                        <a
                                            href={`${props.website.website.twitter}`}
                                        >
                                            {" "}
                                            <TwitterIcon />
                                        </a>
                                    ) : (
                                            <a href={`#`}>
                                                {" "}
                                                <TwitterIcon />
                                            </a>
                                        )}
                                </Grid>
                                <Grid item>
                                    {props.website.website ? (
                                        <a
                                            href={`mailto:${props.website.website.mail}`}
                                        >
                                            <MailRoundedIcon />
                                        </a>
                                    ) : (
                                            <a href={`#`}>
                                                <MailRoundedIcon />
                                            </a>
                                        )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <br />
                        <Grid item>
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                direction="row"
                            >
                                <Grid item>
                                    <Button
                                        style={{
                                            marginRight: "0.5rem",
                                            color: "#fff",
                                        }}
                                        variant="text"
                                        // color="white"
                                        // className={classes.button}
                                        startIcon={props.website.website.phone1 == "" ? null : <PhoneRoundedIcon />}
                                    >
                                        {props.website.website
                                            ? props.website.website.phone1
                                            : ""}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        style={{
                                            marginRight: "0.5rem",
                                            color: "#fff",
                                        }}
                                        variant="text"
                                        // color="primary"
                                        // className={classes.button}
                                        startIcon={props.website.website.phone2 == "" ? null : <PhoneRoundedIcon />}
                                    >
                                        {props.website.website
                                            ? props.website.website.phone2
                                            : ""}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        style={{
                                            color: "#fff",
                                        }}
                                        variant="text"
                                        // color="primary"
                                        // className={classes.button}
                                        startIcon={props.website.website.phone3 == "" ? null : <PhoneRoundedIcon />}
                                    >
                                        {props.website.website
                                            ? props.website.website.phone3
                                            : ""}
                                    </Button>
                                </Grid>
                            </Grid>{" "}
                        </Grid>{" "}
                        <br />
                        <Grid item>
                            <Typography>
                                {props.website.website
                                    ? props.website.website.works
                                    : ""}
                            </Typography>
                        </Grid>
                        <br />
                        <Grid item>
                            <Typography>
                                {props.website.website
                                    ? props.website.website.footer
                                    : ""}
                            </Typography>
                        </Grid>
                        <br />
                        <Grid item>
                            <Typography style={{ fontWeight: "bold" }}>
                                Copyright &copy; 2020 Kaal Group - All Rights
                                Reserved
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </AppBar>
        </div>
    );
}

const mapStateToProps = (state) => ({
    website: state.website,
});
export default connect(mapStateToProps, {})(Footer);
